import LogoMark from './LogoMark'

interface HudCompassProps {
  /** Real published article count — wire to the WordPress REST total once content exists. */
  articleCount: number
}

// The risk-instrument HUD: a compass needle held just shy of 12 o'clock,
// wired directly to the real Doomsday Clock reading (85 seconds to midnight,
// the closest it has ever been — Bulletin of the Atomic Scientists, Jan 2026).
// Source: https://thebulletin.org/doomsday-clock/2026-statement/
export default function HudCompass({ articleCount }: HudCompassProps) {
  return (
    <div
      className="hud"
      role="img"
      aria-label="Original Savage risk compass, needle held just short of the midnight mark: global risk index 85 seconds to midnight"
    >
      <span className="bracket tl" aria-hidden="true"></span>
      <span className="bracket tr" aria-hidden="true"></span>
      <span className="bracket bl" aria-hidden="true"></span>
      <span className="bracket br" aria-hidden="true"></span>
      <div className="readout r-tl">
        SYS
        <br />
        <b>READY</b>
      </div>
      <div className="readout r-tr">
        RISK
        <br />
        <b className="tnum g">85s</b>
      </div>
      <div className="readout r-bl">
        ARTICLES
        <br />
        <b className="tnum">{articleCount}</b>
      </div>
      <div className="readout r-br">
        STATUS
        <br />
        <span className="g">LIVE</span>
      </div>

      <div className="compass">
        <div className="bezel" aria-hidden="true"></div>
        <div className="bezel major" aria-hidden="true"></div>
        <div className="bezel-ring" aria-hidden="true"></div>
        <div className="cardinal" aria-hidden="true">
          <span className="n">N</span>
          <span className="e">E</span>
          <span className="s">S</span>
          <span className="w">W</span>
        </div>
        <div className="midnight" aria-hidden="true"></div>
        <div className="needle" aria-hidden="true"></div>
        <div className="mark" aria-hidden="true">
          <LogoMark />
        </div>
      </div>
    </div>
  )
}
